import React, { useEffect, useRef } from 'react';
import Particle from '../utils/particles'; // Import the Particle class directly

const ParticleBackground = () => {
  const canvasRef = useRef(null);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    console.log("ParticleBackground mounting, canvas:", canvas);
    
    if (canvas) {
      console.log("Initializing particles");
      // Use the imported Particle class
      new Particle(canvas, {
        particleCount: 70,
        colors: ['#5c27c3', '#9254de', '#7c3fe6']
      });
    }
  }, []);
  
  return <canvas ref={canvasRef} id="particles-canvas" className="particles-canvas"></canvas>;
};

export default ParticleBackground; 